import { useEffect, useState } from 'react'

import { getSiteIdFromUrl } from '../copSiteDetails/services/copSiteDetails.service'
import CopAssetsTreePopup from './CopAssetsTreePopup'

export type CopAssetTreeIconProps = {
  allAssetsLabel?: string
  spareAssetsLabel?: string
  decommissionedAssetsLabel?: string
  errorMessageLabel?: string
  expandAllLabel?: string
  collapseAllLabel?: string
  viewLabel?: string
  allAssetsSiteLabel?: string
  allAssetsSiteLabelValue?: string
  spareAssetsItemLabel?: string
  spareAssetsItemLabelValue?: string
  decommissionedAssetsItemLabel?: string
  decommissionedAssetsItemLabelValue?: string
  viewPagePath?: string
  viewButtonLinksJson?: string
  noAssetMessage?: string
}

export default function CopAssetTreeIcon({
  allAssetsLabel,
  spareAssetsLabel,
  decommissionedAssetsLabel,
  errorMessageLabel,
  expandAllLabel,
  collapseAllLabel,
  viewLabel,
  allAssetsSiteLabel,
  allAssetsSiteLabelValue,
  spareAssetsItemLabel,
  spareAssetsItemLabelValue,
  decommissionedAssetsItemLabel,
  decommissionedAssetsItemLabelValue,
  viewPagePath,
  viewButtonLinksJson,
  noAssetMessage,
}: Readonly<CopAssetTreeIconProps>) {
  const [isOpen, setIsOpen] = useState(false)
  const siteId = getSiteIdFromUrl() ?? ''

  useEffect(() => {
    const openPopup = () => setIsOpen(true)
    document.addEventListener('cop:openAssetsTree', openPopup)
    return () => document.removeEventListener('cop:openAssetsTree', openPopup)
  }, [])

  return (
    <CopAssetsTreePopup
      isOpen={isOpen}
      siteId={siteId}
      onClose={() => setIsOpen(false)}
      allAssetsLabel={allAssetsLabel}
      spareAssetsLabel={spareAssetsLabel}
      decommissionedAssetsLabel={decommissionedAssetsLabel}
      errorMessageLabel={errorMessageLabel}
      expandAllLabel={expandAllLabel}
      collapseAllLabel={collapseAllLabel}
      viewLabel={viewLabel}
      allAssetsSiteLabel={allAssetsSiteLabel}
      allAssetsSiteLabelValue={allAssetsSiteLabelValue}
      spareAssetsItemLabel={spareAssetsItemLabel}
      spareAssetsItemLabelValue={spareAssetsItemLabelValue}
      decommissionedAssetsItemLabel={decommissionedAssetsItemLabel}
      decommissionedAssetsItemLabelValue={decommissionedAssetsItemLabelValue}
      viewPagePath={viewPagePath}
      viewButtonLinksJson={viewButtonLinksJson}
      noAssetMessage={noAssetMessage}
    />
  )
}
